export default "__VITE_ASSET__dE1vPi20__"